module.exports = __webpack_public_path__ + "media/images/bsmart/icons/scheda_verifica_tempo-a92e68711745d5da3bb47010f205d0af.svg";